import EmployeePermissionContainer from 'containers/brand/EmployeePermissionContainer';
import React from 'react';

const EmployeePermissionPage = () => {
  return <EmployeePermissionContainer />;
};

export default EmployeePermissionPage;
